import { gql } from '@apollo/client';
import { DEVICE_FRAGMENT } from '@/entities/device/@x/study';
import PATIENT_FRAGMENT from '../fragments/patientFragment';
import DIAGNOSIS_FRAGMENT from '../fragments/diagnosisFragment';
import LAST_EVALUATION_EVENT_FRAGMENT from '../fragments/lastEvaluationEventFragment';

const BIODIRECT_STUDY_QUERY = gql`
  query biodirect($id: ID!) {
    study(id: $id) {
      id
      friendlyId
      info {
        patient {
          ...PatientFragment
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        diagnosis {
          ...DiagnosisFragment
        }
        followOnStudy {
          studyType
          reportDueDate
        }
      }
      start
      stop
      studyType
      status
      reportDueDate
      timezone
      studyTimeOffset
      ecgUploadProgress
      rma
      artifact {
        date
        resolvedAt
        percentage
        lastIssueFound
        commonIssueFound
      }
      lastStudyHistory {
        time
        status
      }
      hasArtifactReport
      linkedStudies {
        id
      }
      facility {
        id
        name
      }
      device {
        ...DeviceFragment
      }
      initDuration
      lastEvaluationEvent {
        ...LastEvaluationEventFragment
      }
      biofluxDirect {
        status
        id
        senderInformation {
          latestLabel {
            transaction {
              trackingStatus
            }
          }
        }
        recipientInformation {
          latestLabel {
            transaction {
              trackingStatus
            }
          }
        }
      }
      isTest
    }
  }

  ${DEVICE_FRAGMENT}
  ${PATIENT_FRAGMENT}
  ${DIAGNOSIS_FRAGMENT}
  ${LAST_EVALUATION_EVENT_FRAGMENT}
`;

export default BIODIRECT_STUDY_QUERY;
